// Proximidade do aniversário em dias, ignorando o ano: 0 = hoje, positivo =
// faltam N, negativo = foi há N. Fora da janela (default ±7) devolve null.
// 29/02 conta como 28/02 em ano comum.
export function birthdayProximity(birthDate: string, windowDays = 7): number | null {
  const [, m, d] = birthDate.slice(0, 10).split("-").map(Number);
  if (!m || !d) return null;
  const hoje = new Date();
  for (let off = -windowDays; off <= windowDays; off++) {
    const dt = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + off);
    const bissexto = (y: number) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
    const diaAlvo = m === 2 && d === 29 && !bissexto(dt.getFullYear()) ? 28 : d;
    if (dt.getMonth() + 1 === m && dt.getDate() === diaAlvo) return off;
  }
  return null;
}
